import { render, staticRenderFns } from "./DataBindingButton.vue?vue&type=template&id=488ce676&"
import script from "./DataBindingButton.vue?vue&type=script&lang=js&"
export * from "./DataBindingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports